import { graphql } from 'gatsby';
import { PostLayout } from '../../components/entities/post-layout';
import { createGatsbyPageComponent } from '@shapeable/ui';

export default createGatsbyPageComponent('Post', { layout: PostLayout, debug: false });

export const QUERY = graphql`
  query PostQuery($id: ID!) {
    platform {
      post(id: $id) {
        id slug path 
        name
        title 
        pretitle
        subtitle
        published
        content { plain text }
        openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
        intro { plain text }
        outro { text }
        type { id name slug __typename }
        topics { 
          id name slug __typename _schema { label pluralLabel }
          openGraph { id image { id url url2x } }
        }
        trends { 
          id name slug __typename _schema { label pluralLabel }
          openGraph { id image { id url url2x } }
        }
        authors {
          id name slug path
          organisation { id name }
          linkedin
          photo { id url url2x }
          positions {
            id
            primary
            positions {
              id 
              name 
            }
            organisation { id name }
          }
        }
        videos {
          id name url
          thumbnail { id url url2x type }
        }
        imageAssets {
          id name image { id url url2x type }
        }
        organisations {
          id name slug path
          logo { id url url2x type }
        }
        people {
          id name slug path
          organisation { id name }
          linkedin
          position
          photo { id url url2x type }
        }
        embeds {
          citations {
            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
          }
          pages {
            id name slug path
            openGraph {
              title description { plain }
              image { url url2x type }
            }
          }
          people {
            id name slug path
            organisation { id name }
            position
            photo { id url url2x }
          }
          imageAssets {
            id
            slug
            image {
              id url url2x width height type
            }
          }
        }
        
        banners {
          id name slug title description { text } alternateText
          image { 
            id url url2x width height type
          }
        }
      }
    }
  }
`;

